'use strict';

// coffee goes here

// Remember to call Groupon.Performance.pageReady() when the page is completely
// loaded. This will send performance data to Optimize.
//
// More context is available at:
// https://pages.github.groupondev.com/InteractionTier/framework/optimize.html
//
// Sample code:
// $(window).on 'load', ->
//   Groupon.Performance.pageReady()

// Initialize Cookie (is required by cookie consent)

window.Cookie = require('groupon-domain-cookie').fromDocument(document);

require('../../node_modules/jquery-validation/dist/jquery.validate.js');
require('../../node_modules/details-element-polyfill/dist/details-element-polyfill.js');
require('optimize-suite');
require('grpn-ls-polyfills/lib/polyfills-full');

const I18n = require('../../node_modules/grapefruit/lib/I18n.js');

window.I18n = new I18n();

require('../../node_modules/grpn-mx-mixer/dist/js/mixer');
require('../../modules/create_account/frontend');
require('../../modules/app/frontend');
require('../../modules/password_reset/frontend');
